module.exports = __webpack_public_path__ + "static/img/about_bg_05_zh2.96f72b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_05_zh2.png
// module id = Mw3F
// module chunks = 34